import { render } from "./AppFooter.vue?vue&type=template&id=767a4c3a&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"

import "./AppFooter.vue?vue&type=style&index=0&id=767a4c3a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-767a4c3a"

export default script